<template>
  <v-row no-gutters>
    <!-- 统计绘图列表 -->
    <v-col cols="12" class="pa-0">
      <v-card outlined>
        <!-- <v-card-title>统计绘图列表</v-card-title> -->
        <v-card-text style="overflow: auto;">
          <data-table :config="tableOption" :matrix="matrix" ref="dataTable"></data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { userFileStream } from '@/plugins/api';
import DataTable from '@/views/Component/DataTable.vue';
export default {
  props: ['dataSourceParam', 'dataSource'],
  data () {
    return {
      pValueMax: null
    }
  },
  components: { DataTable },
  computed: {
    tableOption () {
      let ret = { cols: [], props: { 'checkbox-config': { checkAll: true } } }, r0 = !this.dataSource ? [] : this.dataSource[0], cols = [2, 3, 8, 9, 12];
      for (let i = 0; i < r0.length; i++) ret.cols.push({ field: i, visible: cols.indexOf(i) != -1 })
      ret.events = {
        'checkbox-change': this.updateChartData,
        'checkbox-all': this.updateChartData
      }
      ret.tools = [
        { name: '下载', color: 'primary', text: true, click: this.onDownloadFile },
        {
          type: 'editor',
          cpt: 'decimal-editor',
          props: { dense: true, outlined: true, 'hide-details': true, class: 'mr-2', label: '<=PValue' },
          events: { change: this.onDataFilter }
        },
      ];
      return ret;
    },
    matrix () {
      return this.Utility.clone(this.dataSource)
    }
  },
  mounted () { this.init() },
  methods: {
    // =============== 勾选绘图表格
    init () {
      // let srs = this.matrix.slice(1, 21);
      // this.$refs.dataTable.$refs.xTable.setCheckboxRow(srs, true);
    },
    updateChartData () {
      let xTable = this.$refs.dataTable.$refs.xTable;
      let srs = xTable.getCheckboxRecords();
      this.$emit('change', srs);
    },
    onDataFilter (e) {
      let matrix;
      if (!e) matrix = this.Utility.clone(this.dataSource);
      else {
        matrix = this.dataSource.filter((row, index) => {
          if(index === 0 || Number(row[12]) <= Number(e)){
            return true
          }else{
            return false
          }
        })
      }
      this.$refs.dataTable.updateMatrix(matrix);
    },
    // =============== 文件下载
    onDownloadFile () {
      userFileStream(this.dataSourceParam);
    }
  }
}
</script>